var { baseLoading, baseMessage } = require('./vab')
var { ui } = require('@libs/dep-private')
var { paramsSerializer, dataSerializer } = require('./common-utils')

var { netConfig: { httpOptions, httpCode } } = ui

/**
 * axios utils
 *
 * @author Shigq
 * @date 2021/11/12 17:52
 */
var axios = require('axios')

/* todo - params */
let loadingInstance

/* todo - methods */
/**
 * handle error code
 *
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
function _handleErrorCode(code, msg, showErrMsg) {
	switch (code) {
		case httpCode.movedTemporarily:
		case httpCode.serviceUnavailable:
		case httpCode.authorizedError:
			baseMessage(`登录已过期，请重新登录`, 'error')
			break
		case httpCode.unauthorized:
			baseMessage(`未授权`, 'error')
			break
		case httpCode.notFound:
			baseMessage(`页面未找到`, 'error')
			break
		default:
			if (showErrMsg) {
				baseMessage(msg || `后端接口${code}异常`, 'error')
			}
			break
	}
}

/**
 * parse response body
 *
 * @param response
 * @returns {{code: string, rspData: string, message: string, config: *}}
 */
function _parseRspBody(response) {
	var {
		data: {
			header: {
				code,
				message
			},
			...rspData
		},
		config
	} = response

	var rsp = {
		code: code,
		message: message,
		rspData: rspData,
		config: config
	}

	return rsp
}

/* todo - instance */
var http = function (options, parseRspBody, handleErrorCode) {
	// init
	var baseURL = options.baseURL || httpOptions.baseURL
	var timeout = options.timeout || httpOptions.timeout
	var contentType = options.contentType || httpOptions.contentType
  var headers = Object.assign({
    'Content-Type': contentType
  }, options.headers)

	// handler
	if (!parseRspBody) {
		parseRspBody = _parseRspBody
	}

	if (!handleErrorCode) {
		handleErrorCode = _handleErrorCode
	}

	// instance
	var instance = axios.create({
		baseURL: baseURL,
		timeout: timeout,
		headers: headers,
		// 格式化[request data] - 适用于[get]
		paramsSerializer: function (param) {
			return paramsSerializer(param)
		},
		// 格式化[request data] - 适用于[put, post, patch]
		withCredentials: true,
		transformRequest: [
			(data, headers) => {
				if(headers['Content-Type'] === 'application/x-www-form-urlencoded') {
					return data
				}
				return dataSerializer(data)
			},
			...axios.defaults.transformRequest
		]
	})

	instance.interceptors.request.use(
		config => {
			if (config.loading) {
				loadingInstance = baseLoading()
			}
			return config;
		},
		error => {
			console.log(error);
			return Promise.reject();
		}
	)

	instance.interceptors.response.use(
		response => {
			if (loadingInstance) {
				loadingInstance.close()
			}

			const {
				code,
				message,
				rspData,
				config
			} = parseRspBody(response)

			// 是否操作正常
			if (httpCode.success.includes(code)) {
				if (config.useCommon) baseMessage()
				return rspData
			} else {
				handleErrorCode(code, message, config.showErrMsg !== false)
				return Promise.reject('请求异常拦截:' + JSON.stringify({url: config.url, code, message}) || 'Error')
			}
		},
		error => {
			if (loadingInstance) {
				loadingInstance.close()
			}

			const {response, message} = error
			if (error.message.startsWith('timeout')) {
				baseMessage(`请求超时`, 'error')
				return Promise.reject(error)
			}
			const {status, data} = response;

			handleErrorCode(status, data.msg || message)

			return Promise.reject(error)
		}
	);

	return instance
}

module.exports = http
